import { createContext } from 'react';
import type { DropdownContextType } from './DropdownContext.types';

export const DropdownContext = createContext<DropdownContextType | null>(null);
